import React, { useState } from 'react';
import DropdownMenu from './DropdownMenu';
import FilterConversationItem from './FilterConversationItem';

const conversation_filters_row_1 = [
  { label: 'Missed call', value: 'MISSED_CALL' },
  { label: 'Missed call + voicemail', value: 'MISSED_CALL_VM' },
  { label: 'Direct text', value: 'DIRECT_MESSAGE' },
];
const conversation_filters_row_2 = [
  { label: 'Reminders', value: 'APPOINTMENT_REMINDER' },
  { label: 'Web chat', value: 'WEB_CHAT' },
  { label: 'Lead Engage', value: 'FORM_SUBMISSION' },
];
const conversation_filters_row_2_dental = [
  { label: 'Reminders', value: 'APPOINTMENT_REMINDER' },
  { label: 'Web to text', value: 'WEB_TO_TEXT' },
  { label: 'Lead Engage', value: 'FORM_SUBMISSION' },
  { label: 'Online Booking', value: 'WEB_STORE' },
];
const conversation_tags_row_1 = [
  { label: 'Booking', value: 'BOOKING' },
  { label: 'Booking Request', value: 'BOOKING_REQUEST' },
  { label: 'Reschedule', value: 'RESCHEDULE' },
  { label: 'Reschedule Request', value: 'RESCHEDULE_REQUEST' },
  { label: 'Cancel', value: 'CANCELLATION' },
  { label: 'Cancel Request', value: 'CANCEL_REQUEST' },
];
const conversation_tags_row_2 = [
  { label: 'New Customer', value: 'NEW' },
  { label: 'Happy', value: 'HAPPY' },
  { label: 'Unhappy', value: 'UNHAPPY' },
  { label: 'Landline', value: 'IS_LANDLINE' },
  { label: 'Unresponsive', value: 'UNRESPONSIVE' },
];

const conversation_tags_row_3 = [
  { label: 'Campaign in progress', value: 'LE_CAMPAIGN_IN_PROGRESS' },
  { label: 'Booked on TrueLark', value: 'LE_BOOKED_ON_TRUELARK' },
  { label: 'Booked off-platform', value: 'LE_BOOKED_OFF_PLATFORM' },
];

const conversation_tags_row_4 = [
  { label: 'Engaged', value: 'LE_ENGAGED' },
  { label: 'Unresponsive', value: 'LE_UNRESPONSIVE' },
  { label: 'Opted-out', value: 'LE_OPTED_OUT' },
  { label: 'Expired campaign', value: 'LE_EXPIRED_CAMPAIGN' },
];

const conversation_tags_row_2_dental = [
  { label: 'New Patient', value: 'NEW' },
  { label: 'Happy', value: 'HAPPY' },
  { label: 'Unhappy', value: 'UNHAPPY' },
  { label: 'Landline', value: 'IS_LANDLINE' },
  { label: 'Unresponsive', value: 'UNRESPONSIVE' },
];

const insurance_status = [
  { label: 'Using insurance', value: 'USING_INSURANCE' },
  { label: 'Paying out-of-pocket', value: 'OUT_OF_POCKET' },
];
const conversation_status = [
  { label: 'Needs Attention', value: 'FOLLOWUP_NEEDED' },
  { label: 'Auto-response paused', value: 'PAUSED' },
];
const conversation_assignement = [
  { label: 'Me', value: 'ME' },
  { label: 'Others', value: 'OTHERS' },
  { label: 'None', value: 'NONE' },
];

const reminders_row_1 = [
  { label: 'Confirmed', value: 'APPOINTMENT_REMINDER_CONFIRMED' },
  { label: 'Rescheduled', value: 'APPOINTMENT_REMINDER_RESCHEDULED' },
  { label: 'Canceled', value: 'APPOINTMENT_REMINDER_CANCELLED' },
  { label: 'Cancelation requested', value: 'APPOINTMENT_REMINDER_CANCEL_REQUESTED' },
];
const reminders_row_2 = [
  { label: 'Reschedule requested', value: 'APPOINTMENT_REMINDER_RESCHEDULE_REQUESTED' },
  { label: 'In progress', value: 'APPOINTMENT_REMINDER_IN_PROGRESS' },
  { label: 'Unresponsive', value: 'APPOINTMENT_REMINDER_UNCONFIRMED' },
  { label: 'Opted out', value: 'APPOINTMENT_REMINDER_OPTED_OUT' },
];

const FilterConversations = ({
  addOnNotEnabled,
  onChange,
  filter,
  clearFilter,
  applyFilter,
  selectedOption,
  domain,
  features,
  custom_tags,
  ...rest
}) => {
  const source_row_2 =
    domain === 'DENTAL'
      ? conversation_filters_row_2_dental
      : conversation_filters_row_2;
  const tags_row_2 =
    domain === 'DENTAL'
      ? conversation_tags_row_2_dental
      : conversation_tags_row_2;
  console.log('custom_tags', custom_tags);
  return (
    <DropdownMenu {...rest}>
      <div className="options-group">
        <div className="sources">
          <div className="title">Source</div>
          <div className="multi-row-filter">
            <div className="filter-row">
              {conversation_filters_row_1.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
            <div className="filter-row">
              {source_row_2.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
          </div>
        </div>

        <div className="sources">
          <div className="title">TAGS</div>
          <div className="multi-row-filter">
            <div className="filter-row">
              {conversation_tags_row_1.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
            <div className="filter-row">
              {tags_row_2.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
          </div>
        </div>
        {custom_tags?.length > 0 &&
          <div className="sources">
            <div className="title">CUSTOM TAGS</div>
            <div className="multi-row-filter">
              <div className="filter-row">
                {custom_tags.slice(0, 5).map((item, index) => {
                  return (
                    <FilterConversationItem
                      label={item.name}
                      key={index}
                      value={item.name}
                      onClick={onChange}
                      type="BUTTON"
                      className={''}
                      iconclassName={'fas fa-flag'}
                      selectedOption={selectedOption}
                      filter={filter}
                    />
                  );
                })}
              </div>
              <div className="filter-row">
                {custom_tags.slice(5).map((item, index) => {
                  return (
                    <FilterConversationItem
                      label={item.name}
                      key={index}
                      value={item.name}
                      onClick={onChange}
                      type="BUTTON"
                      className={''}
                      iconclassName={'fas fa-flag'}
                      selectedOption={selectedOption}
                      filter={filter}
                    />
                  );
                })}
              </div>
            </div>
          </div>}

        {features && features.includes('LEAD_ENGAGE_ENABLED') && (
          <div className="tags">
            <div className="title">LEAD ENGAGE</div>
            <div className="multi-row-filter">
              <div className="filter-row">
                {conversation_tags_row_3.map((item, index) => {
                  return (
                    <FilterConversationItem
                      label={item.label}
                      key={index}
                      value={item.value}
                      onClick={onChange}
                      type="BUTTON"
                      className={''}
                      iconclassName={'fas fa-flag'}
                      selectedOption={selectedOption}
                      filter={filter}
                    />
                  );
                })}
              </div>
              <div className="filter-row">
                {conversation_tags_row_4.map((item, index) => {
                  return (
                    <FilterConversationItem
                      label={item.label}
                      key={index}
                      value={item.value}
                      onClick={onChange}
                      type="BUTTON"
                      className={''}
                      iconclassName={'fas fa-flag'}
                      selectedOption={selectedOption}
                      filter={filter}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}

        <div className="tags">
          <div className="title">Appointment reminders</div>
          <div className="multi-row-filter">
            <div className="filter-row">
              {reminders_row_1.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
            <div className="filter-row">
              {reminders_row_2.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
          </div>
        </div>
        {domain === 'DENTAL' &&
        <div className="tags">
          <div className="title">INSURANCE</div>
          <div className="multi-row-filter">
            <div className="filter-row">
              {insurance_status.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
          </div>
        </div>}
        {!addOnNotEnabled && (
          <>
            <div className="tags">
              <div className="title">STATUS</div>
              <div className="multi-row-filter">
                <div className="filter-row">
                  {conversation_status.map((item, index) => {
                    return (
                      <FilterConversationItem
                        label={item.label}
                        key={index}
                        value={item.value}
                        onClick={onChange}
                        type="BUTTON"
                        className={''}
                        iconclassName={'fas fa-flag'}
                        selectedOption={selectedOption}
                        filter={filter}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="assignee">
              <div className="title">ASSIGNED TO</div>
              <div className="multi-row-filter">
                <div className="filter-row">
                  {conversation_assignement.map((item, index) => {
                    return (
                      <FilterConversationItem
                        label={item.label}
                        key={index}
                        value={item.value}
                        onClick={onChange}
                        type="BUTTON"
                        className={''}
                        iconclassName={'fas fa-flag'}
                        selectedOption={selectedOption}
                        filter={filter}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="actions">
        <button
          className="btn btn--primary btn--lg apply"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            applyFilter();
          }}
        >
          APPLY
        </button>
        <div
          className="clear"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            clearFilter();
          }}
        >
          clear selection
        </div>
      </div>
    </DropdownMenu>
  );
};

export default FilterConversations;
